import Head from "next/head";

function SiteLinkMeta() {
  const microdata = {
    "@context": "http://schema.org",
    "@type": "WebSite",
    name: "Parts Avatar",
    url: "https://partsavatar.ca/",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://partsavatar.ca/search?ph={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(microdata) }}
      />
    </Head>

  );
}

export default SiteLinkMeta;
